// TypeScript
import { NavigateFunction, NavigateOptions } from 'react-router-dom';

let navigateRef: NavigateFunction | null = null;

/** Guarda la referencia al navigate de React-Router */
export const setNavigate = (nav: NavigateFunction) => {
  navigateRef = nav;
};

/** Función utilitaria para navegar desde cualquier sitio */
export const goTo = (
  to: string,
  opts?: NavigateOptions,
) => {
  if (navigateRef) {
    navigateRef(to, opts);
  } else {
    // Fallback de emergencia; evita quedarnos “colgados”
    window.location.href = to;
  }
};
